<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="close()" text=""></ion-back-button>
    </ion-buttons>
    <ion-title>Hotkeys</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h1>Alle Tastenkombinationen</h1>

  <h2>Global</h2>
  <section class="h-area">
    @for (item of globalHotkeys; track item; let i = $index) {
      <hotkey-row [row]="item" [withBorder]="i < globalHotkeys.length - 1"></hotkey-row>
    }
  </section>

  <h2>Ticketübersicht</h2>
  <section class="h-area">
    @for (item of ticketOverviewHotkeys; track item; let i = $index) {
      <hotkey-row [row]="item" [withBorder]="i < ticketOverviewHotkeys.length - 1"></hotkey-row>
    }
  </section>

  <h2>Ticket</h2>
  <section class="h-area">
    @for (item of ticketDetailHotkeys; track item; let i = $index) {
      <hotkey-row [row]="item" [withBorder]="i < ticketDetailHotkeys.length -1"></hotkey-row>
    }
  </section>

  <h2>Boards</h2>
  <section class="h-area">
    @for (item of boards; track item; let i = $index) {
      <hotkey-row [row]="item" [withBorder]="i < boards.length -1"></hotkey-row>
    }
  </section>

  <h2>Ticketzeiten-Übersicht (Wenn ausgewählt)</h2>
  <section class="h-area">
    @for (item of ticketTime; track item; let i = $index) {
      <hotkey-row [row]="item" [withBorder]="i < ticketTime.length -1"></hotkey-row>
    }
  </section>


</ion-content>